/**
 * whole angle of the liveView divided with the length of the items minus one
 */
export const calculateItemAngle = (liveViewAngle: number, itemCount: number): number => {
  return (liveViewAngle * 2) / (itemCount - 1)
}

interface CalculateSubItemAngleProps {
  subItemsLength: number
  index: number
  downMd: boolean
  itemsLength: number
}
/*
 * max angle left and right are 15deg * amount of items.
 * e.g. 4 items. 1 item: -60deg, 2 item: -20deg, 3 item: 20deg, 4 item: 60deg
 * e.g. 3 items. 1 item: -45deg, 2 item: 0 deg, 3 item 45deg
 */
export const calculateSubItemAngle = ({ subItemsLength, index, downMd, itemsLength }: CalculateSubItemAngleProps): number => {
  const maxAngle = itemsLength === 4 ? 30 : 40

  if (downMd) return ((maxAngle * 2) / (subItemsLength - 1)) * index - maxAngle
  return index * (90 / (subItemsLength - 1))
}

export const clamp = (number: number, min: number, max: number): number => Math.min(Math.max(number, min), max)

/**
 * Total consumption shown in the live view (home consumption + charging wallboxes).
 * A discharging wallbox (negative power, e.g. EDSN) feeds energy into the home, so it must not reduce the consumption.
 */
export const getConsumptionPower = (consumption?: number | null, homeWallboxPower?: number | null): number =>
  (consumption ?? 0) + Math.max(homeWallboxPower ?? 0, 0)
